import React from 'react';

import cn from 'classnames';

import { Icon, Input, UiDropdown, UiDropdownSearchList, UiText } from '@shared/ui';

import cls from './AddWarehouse.module.css';
import { useAddWarehouse } from '../model/useAddWarehouse';

export const AddWarehouse = () => {
    const {
        t,
        mode,
        warehouseTitle,
        setWarehouseTitle,
        contentRef,
        availableProjectsQuery,
        isWarehouseCreating,
        handleOpenChange,
        selectProjectMode,
        selectCustomMode,
        createProjectWarehouse,
        handleTitleKeyDown,
        handleTitleBlur,
    } = useAddWarehouse();

    return (
        <UiDropdown
            placement="right-start"
            className={cls.dropdown}
            onOpenChange={handleOpenChange}
            renderTrigger={({ ref, referenceProps }) => (
                <button
                    ref={ref}
                    type="button"
                    className={cls.addWarehouseButton}
                    data-id="add-warehouse-button"
                    {...referenceProps}
                    disabled={isWarehouseCreating}
                    aria-busy={isWarehouseCreating}
                >
                    {t('AddWarehouseButton.render.text')}
                </button>
            )}
        >
            {({ close }) => (
                <div ref={contentRef} className={cls.content}>
                    <div className={cls.titleRow}>
                        {mode === 'custom' ? (
                            <Input
                                autoFocus
                                maxLength={255}
                                value={warehouseTitle}
                                onChange={(event) => setWarehouseTitle(event.target.value)}
                                onKeyDown={(event) => handleTitleKeyDown(event, close)}
                                onBlur={(event) => handleTitleBlur(event, close)}
                                placeholder={t('AddWarehouseButton.render.input.inputValue')}
                                classes={[cls.titleInputWrapper]}
                                inputClassName={cls.titleInput}
                            />
                        ) : (
                            <UiText tag="span" variant="subPlain" weight="medium">
                                {warehouseTitle}
                            </UiText>
                        )}
                    </div>

                    <div className={cls.modeList}>
                        <button
                            type="button"
                            className={cn(cls.modeButton, {
                                [cls.activeModeButton]: mode === 'project',
                            })}
                            data-id="project-button"
                            disabled={isWarehouseCreating}
                            onClick={selectProjectMode}
                        >
                            <Icon iconName="house" width={14} height={14} />
                            {t('AddWarehouseModal.render.onProject')}
                        </button>
                        <button
                            type="button"
                            className={cn(cls.modeButton, {
                                [cls.activeModeButton]: mode === 'custom',
                            })}
                            data-id="other-warehouse-button"
                            disabled={isWarehouseCreating}
                            onClick={selectCustomMode}
                        >
                            {t('AddWarehouseModal.render.onOther')}
                        </button>
                    </div>

                    {mode === 'project' && (
                        <UiDropdownSearchList
                            title={t('AddWarehouseModal.render.SearchModal.titleText')}
                            items={availableProjectsQuery.data ?? []}
                            className={cls.projectSearchList}
                            hideCloseButton
                            emptyText={
                                availableProjectsQuery.isLoading
                                    ? undefined
                                    : t('SearchModal.emptyProjectList.text')
                            }
                            onClose={close}
                            onItemClick={(project) => {
                                void createProjectWarehouse(project.id, close);
                            }}
                        />
                    )}
                </div>
            )}
        </UiDropdown>
    );
};
